import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import useFetchCredential from '../../hooks/useFetchCredential';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { UilEye } from '@iconscout/react-unicons';

const makeStyle = (status) => {
  if (status === 'Approved') {
    return {
      background: 'rgb(145 254 159 / 47%)',
      color: 'green',
    };
  } else if (status === 'Pending') {
    return {
      background: '#59bfff',
      color: 'white',
    };
  } else {
    return {
      background: '#ffadad8f',
      color: 'red',
    };
  }
};

export default function DashboardTable() {
  const { data, loading, error } = useFetchCredential(
    `${process.env.REACT_APP_API_URL}/marketers/recent-commissions`
  );

  const successNotification = (message) => toast.success(message);

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'NGN',
  });

  return (
    <div className="Table withdrawalTable">
      <h3>Recent Earnings</h3>
      {data && (
        <TableContainer component={Paper} className="dashTable" style={{ height: 'auto' }}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Trans. ID</TableCell>
                <TableCell align="left">Done On</TableCell>
                <TableCell align="left">Transacted Amount</TableCell>
                <TableCell align="left">Amount Earned</TableCell>
                <TableCell align="left">Traded By</TableCell>
                <TableCell align="left">Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody style={{ color: 'white' }}>
              {data.map((row, index) => {
                let subDate;
                var dateString = new Date(row.date).toString();
                var splittedDateString = dateString.split(' ');
                var day = splittedDateString[0];
                var day2 = splittedDateString[1];
                var month = splittedDateString[2];
                var year = splittedDateString[3];
                subDate = `${day}, ${day2} ${month}, ${year}`;

                const copyText = () => {
                  const txt = row.comID;
                  const input = document.createElement('input');
                  input.value = txt;
                  document.body.appendChild(input);
                  input.select();
                  document.execCommand('copy');
                  document.body.removeChild(input);
                  successNotification('Transaction ID copied');
                };

                return (
                  <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell align="left" onClick={copyText}>
                      {row.comID.substring(0, 15)}...
                    </TableCell>
                    <TableCell align="left">{subDate}</TableCell>
                    <TableCell align="left" className="amount">
                      {formatter.format(row.trade_amount)}
                    </TableCell>
                    <TableCell align="left" className="amount">
                      {formatter.format(row.commission_amount)}
                    </TableCell>
                    <TableCell align="left">{row.trader}</TableCell>
                    <TableCell align="left">
                      <span className="status" style={makeStyle(row.status)}>
                        row.status
                      </span>
                    </TableCell>
                    <TableCell align="left">
                      <Link to={`/investment-details`}>
                        <UilEye color="#121212" />
                      </Link>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      {loading && <div style={{ color: 'red !important', fontSize: '25px' }}>Loading...</div>}
      {error && <div style={{ color: 'red !important', fontSize: '25px' }}>{error}</div>}
    </div>
  );
}
